import React from 'react'

import { Grid, Input, SimpleCollapse } from 'components'
import { SPACING } from 'utils'

export interface IContratoPrincipalCollapse {
  control: any
  errors: any
}
const ContratoPrincipalCollapse: React.FC<IContratoPrincipalCollapse> = ({
  control,
  errors
}) => {
  return (
    <SimpleCollapse title="DADOS DO CONTRATO PRINCIPAL">
      <Grid
        gridCols="1fr 2fr 5fr"
        gridGap={`0 ${SPACING.spacing20}`}
        margin={`${SPACING.spacing10} 0 ${SPACING.spacing5} 0`}
      >
        <Input
          control={control}
          errors={errors}
          label="Contrato"
          placeholder="Nº"
          formValue="cdContratoPrincipal"
          disabled
        />
        <Input
          control={control}
          errors={errors}
          label="Fornecedor"
          placeholder="Nome do Fornecedor"
          formValue="nmFornecedorPrincipal"
          disabled
        />
        <Input
          control={control}
          errors={errors}
          label="Objeto do Contrato"
          placeholder="Objeto do Contrato"
          formValue="txObjetoContratoPrincipal"
          disabled
        />
      </Grid>
    </SimpleCollapse>
  )
}

export default ContratoPrincipalCollapse
